import React from "react";
import {Subscription} from "../../../types/Subscription";
import {useAdmin} from "../../../contexts/AdminContext";
import Heading from "../../../components/Heading";
import {useTranslation} from "react-i18next";
import cx from "classnames";
import styles from "./SubscriptionTable.module.css";

const Index: React.FC<{subscriptions: Subscription[], changePage: (p: string) => void}> = (
    {
        subscriptions,
        changePage,
    }
) => {
    const { chooseSub } = useAdmin()
    const { t } = useTranslation(['settings'])
    return (
        <div className={'mt-6'}>
            <Heading level={3}>{t("subscription.yourSubs")}</Heading>
            <table className={'w-100'}>
                <thead className={cx(styles['row'])}>
                <tr>
                    <th>{t("subscription.products")}</th>
                    <th>{t("subscription.key")}</th>
                    <th>Host</th>
                    <th>Status</th>
                    <th/>
                </tr>
                </thead>
                <tbody>
                {subscriptions.map((sub) => {
                    return (
                        <tr className={'mb-3'}>
                            <td>
                                <ul className={cx(styles['list'])}>
                                    {sub.plans.map((plan) => {
                                        return (<li>
                                            {plan.name} ({plan.price.toString().replace('.', ',') + ' €'})
                                        </li>)
                                    })}
                                </ul>
                            </td>
                            <td>{sub.stripe_id}</td>
                            <td>{sub.host}</td>
                            <td>
                                {(sub.stripe_status === 'active' && !sub.end_date) && t("subscription.statusValues.active")}
                                {(sub.stripe_status === 'active' && sub.end_date) && t("subscription.statusValues.active_until", {'date': sub.end_date})}
                                {(sub.stripe_status === 'canceled') && t("subscription.statusValues.canceled")}
                                {(sub.stripe_status === 'past_due') && t("subscription.statusValues.past_due")}
                                {(sub.stripe_status === 'incomplete') && t("subscription.statusValues.incomplete")}
                            </td>
                            <td>
                                <div className={'d-flex w-100 justify-content-end'}>
                                    <u
                                        className={'font-weight-bold cursor-pointer'}
                                        onClick={() => {
                                            chooseSub(sub)
                                            changePage('change_plan')
                                        }}
                                    >
                                        {t("subscription.change")}
                                    </u>
                                </div>
                            </td>
                        </tr>
                    )
                })}
                </tbody>
            </table>
        </div>
    )
}

export default Index
